import { render, staticRenderFns } from "./taking-query.vue?vue&type=template&id=0c8eb4a8&scoped=true&"
import script from "./taking-query.vue?vue&type=script&lang=js&"
export * from "./taking-query.vue?vue&type=script&lang=js&"
import style0 from "./taking-query.vue?vue&type=style&index=0&id=0c8eb4a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8eb4a8",
  null
  
)

export default component.exports